import {
  GET_ALL_DATA_DPF_REQUESTS,
  GET_ALL_DATA_DPF_REQUESTS_METADATA,RESET_DPF_REQUESTS
} from '../../constants/reducerTypes';

const initialState = {
  dpfDataCollection: [],
  requestDPFLoader: true,
  requestDPFMetadataLoader: true,
};
const requestAccessDPFReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_ALL_DATA_DPF_REQUESTS:
      return {
        ...state,
        dpfCollection: action?.payload?.dpfresults ? [...action.payload.dpfresults] : [],
        requestDPFLoader: false,
      };
    case GET_ALL_DATA_DPF_REQUESTS_METADATA:
      return {
        ...state,
        dpfDataCollection: action?.payload?.dpfDataResults
          ? [...action.payload.dpfDataResults]
          : [],
        requestDPFMetadataLoader: false,
      };
      case RESET_DPF_REQUESTS:
        return initialState
    default:
      return state;
  }
};
export default requestAccessDPFReducer;
